import { render, staticRenderFns } from "./EditUserDialog.vue?vue&type=template&id=132aa3ee&scoped=true"
import script from "./EditUserDialog.vue?vue&type=script&lang=js"
export * from "./EditUserDialog.vue?vue&type=script&lang=js"
import style0 from "./EditUserDialog.vue?vue&type=style&index=0&id=132aa3ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132aa3ee",
  null
  
)

export default component.exports